import type { Venue } from '../../types/venue';

export const elleryBeachHouse: Venue = {
  id: 'ellery-beach-house',
  name: 'Ellery Beach House',
  description: {
    en: `<p>Welcome to Ellery Beach House on Elfviks udde in Lidingö.</p>
    
    <p>Ellery is inspired by the 60s and 70s and has a passion for design, music, and art. Their love for cozy, warm environments makes Ellery a retreat, an experience, a hotel, a destination where you can be the best version of yourself.</p>
    
    <p>With the sea as a neighbor and only 18 minutes from Stockholm city, a unique and tailored conference experience awaits with service that is always close and genuine, in an elegant and relaxing archipelago environment far away from everyday life.</p>
    
    <p>Stockholm's first Beach Club with indoor and outdoor pools, fire relaxation areas, sauna pier, and sun loungers. Billiards table, running track, padel and boule courts – there are activities for all tastes.</p>
    
    <p>All 122 modernly furnished hotel rooms can be used as double rooms with twin beds, which can be an extra plus for your conferences. All hotel rooms have views of the sea and nature.</p>
    
    <p>60 of the rooms are in the main building and the other 62 rooms are in a completely new building right next to the main building. 4 of the hotel rooms are handicap accessible and located in the new building.</p>
    
    <p>Ellery Beach House has 11 wonderful meeting rooms, all with a fantastic view of the sea, projector or screen in the room, and some other necessities for your meetings and events. The largest meeting room also has a stage.</p>
    
    <p>Get ready to be inspired, crack ingenious ideas, and make really good decisions in the cozy meeting facilities, and then spend well-deserved quality time with colleagues in their Beach Club, restaurants, or why not run a small padel tournament?</p>`,
    
    sv: `<p>Välkommen till Ellery Beach House på Elfviks udde på Lidingö.</p>
    
    <p>Ellery inspireras av 60 och 70-talet och brinner för design, musik och konst. Deras förkärlek för ombonade, varma miljöer gör Ellery till en tillflyktsort, en retreat, en upplevelse, ett hotell, en destination där du får vara den bästa varianten av dig själv.</p>
    
    <p>Med havet som granne och endast 18 min från Stockholm city väntas en unik och skräddarsydd konferensupplevelse med en service som alltid är nära och äkta, i en elegant och avkopplande skärgårdsmiljö långt bort från vardagen.</p>
    
    <p>Stockholms första Beach Club med inomhus- och utomhuspooler, eldrelax, bastubrygga och solsängar. Biljardbord, löpspår, padel och boulebanor – här finns aktiviteter för alla smaker.</p>
    
    <p>Alla de 122 modernt inredda hotellrummen kan användas som dubbelrum med twinbed vilket kan vara ett extra plus för era konferenser. Alla hotellrummen har utsikt över havet och naturen.</p>
    
    <p>60 utav rummen finner ni i huvudbyggnaden och de andra 62 rummen finns i en helt ny byggnad precis bredvid huvudbyggnaden. 4 av hotellrummen är handikappanpassade och belagda i den nya byggnaden.</p>
    
    <p>Ellery Beach House har 11 härliga mötesrum och dem har alla en fantastisk utsikt över havet, projektor eller skärm i rummet och några andra nödvändigheter för era möten och event. I det största mötesrummet finns även en scen.</p>
    
    <p>Gör er redo att inspireras, knäcka genialiska idéer och ta riktigt bra beslut i de ombonade möteslokalerna, för att sedan spendera välförtjänt quality time med kollegorna i deras Beach Club, restauranger, eller varför inte köra en liten padelturnering?</p>`,
    
    no: `<p>Velkommen til Ellery Beach House på Elfviks udde på Lidingö.</p>
    
    <p>Ellery er inspirert av 60- og 70-tallet og brenner for design, musikk og kunst. Deres forkjærlighet for lune, varme miljøer gjør Ellery til et tilfluktssted, et retreatsted, en opplevelse, et hotell, en destinasjon hvor du kan være den beste versjonen av deg selv.</p>
    
    <p>Med havet som nabo og kun 18 minutter fra Stockholm sentrum venter en unik og skreddersydd konferanseopplevelse med service som alltid er nær og ekte, i et elegant og avslappende skjærgårdsmiljø langt borte fra hverdagen.</p>
    
    <p>Stockholms første Beach Club med innendørs og utendørs bassenger, bålrelax, badstubrygg og solsenger. Biljardbord, løpespor, padel og bocciabaner – her er det aktiviteter for alle smaker.</p>`,
    
    da: `<p>Velkommen til Ellery Beach House på Elfviks udde på Lidingö.</p>
    
    <p>Ellery er inspireret af 60'erne og 70'erne og brænder for design, musik og kunst. Deres forkærlighed for hyggelige, varme miljøer gør Ellery til et tilflugtssted, et retreat, en oplevelse, et hotel, en destination, hvor du kan være den bedste version af dig selv.</p>
    
    <p>Med havet som nabo og kun 18 minutter fra Stockholm centrum venter en unik og skræddersyet konferenceoplevelse med service, der altid er tæt på og ægte, i et elegant og afslappende skærgårdsmiljø langt væk fra hverdagen.</p>
    
    <p>Stockholms første Beach Club med indendørs og udendørs pools, bålrelaxområder, saunabrygge og solstole. Billardbord, løbespor, padel og petanquebaner – her er aktiviteter for alle smag.</p>`
  },
  image: '/assets/images/ellery.jpg',
  country: 'se',
  region: 'stockholm',
  city: 'Lidingö',
  address: 'Elfviks udde, 18190 Lidingö, Sweden',
  coordinates: {
    lat: 59.364220407573264,
    lng: 18.253982194332004
  },
  capacity: {
    min: 5,
    max: 300
  },
  rating: 4.6,
  reviews: Array.from({ length: 120 }, (_, i) => ({
    id: `review-${i}`,
    userId: `user-${i}`,
    rating: 4.6,
    comment: '',
    date: new Date().toISOString()
  })),
  amenities: ['wifi', 'coffee', 'restaurant', 'pool', 'spa'],
  images: [
    '/assets/images/ellery.jpg',
    'https://images.unsplash.com/photo-1566073771259-6a8506099945?q=80&w=1740&auto=format&fit=crop',
    'https://images.unsplash.com/photo-1520250497591-112f2f40a3f4?q=80&w=1740&auto=format&fit=crop'
  ],
  priceRange: {
    min: 3500,
    max: 25000
  },
  recommended: false,
  factbox: {
    rooms: 122,
    conferenceRooms: 11,
    meetingCapacity: 300,
    features: [
      '122 modern hotel rooms with sea views',
      '11 meeting rooms with sea views',
      'Indoor and outdoor pools',
      'Beach Club',
      'Sauna pier',
      'Padel courts',
      'Boule courts',
      'Billiards',
      'Running track',
      'Fire relaxation areas',
      'Only 18 minutes from Stockholm city',
      'Handicap accessible rooms',
      'Stage in largest meeting room',
      'Projectors and screens in all meeting rooms',
      'Restaurant and bar facilities',
      'Archipelago environment'
    ]
  }
}; 